export default __webpack_public_path__ + "static/media/home-image.4449a2ea.jpg";